function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Clear({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 2C6.487 2 2 6.486 2 12s4.487 10 10 10c5.514 0 10-4.486 10-10S17.514 2 12 2zM7.855 7.855a1 1 0 011.414 0L12 10.586l2.73-2.731a1 1 0 011.414 1.415L13.414 12l2.73 2.73a1 1 0 11-1.414 1.415L12 13.414l-2.731 2.731a1 1 0 11-1.414-1.415L10.586 12 7.855 9.27a1.002 1.002 0 010-1.415z",
    fill: props.color || "#5C50BB",
    fillRule: "evenodd"
  }));
}

const MemoClear = React.memo(Clear);
export default MemoClear;